/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RecordInputs */

const th_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติ`)
};

const en_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record`)
};

const ja_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戦績`)
};

const zh_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`战绩`)
};

const es_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance`)
};

const pt_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campanha`)
};

const id_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekor`)
};

const fr_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilan`)
};

const tl_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekord`)
};

const vi_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích`)
};

const ko_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전적`)
};

const de_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilanz`)
};

const ru_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Баланс`)
};

const tr_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilanço`)
};

const it_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilancio`)
};

const pl_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilans`)
};

const uk_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Баланс`)
};

const hi_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड`)
};

const ar_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السجل`)
};

const ms_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekod`)
};

const bn_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেকর্ড`)
};

const zh_tw2_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戰績`)
};

const zh_hk2_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戰績`)
};

const ur_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ریکارڈ`)
};

const fa_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کارنامه`)
};

const sw_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekodi`)
};

const nl_record = /** @type {(inputs: RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balans`)
};

/**
* | output |
* | --- |
* | "Record" |
*
* @param {RecordInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const record = /** @type {((inputs?: RecordInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RecordInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_record(inputs)
	if (locale === "ja") return ja_record(inputs)
	if (locale === "zh") return zh_record(inputs)
	if (locale === "es") return es_record(inputs)
	if (locale === "pt") return pt_record(inputs)
	if (locale === "id") return id_record(inputs)
	if (locale === "fr") return fr_record(inputs)
	if (locale === "tl") return tl_record(inputs)
	if (locale === "vi") return vi_record(inputs)
	if (locale === "ko") return ko_record(inputs)
	if (locale === "de") return de_record(inputs)
	if (locale === "ru") return ru_record(inputs)
	if (locale === "tr") return tr_record(inputs)
	if (locale === "it") return it_record(inputs)
	if (locale === "pl") return pl_record(inputs)
	if (locale === "uk") return uk_record(inputs)
	if (locale === "hi") return hi_record(inputs)
	if (locale === "ar") return ar_record(inputs)
	if (locale === "ms") return ms_record(inputs)
	if (locale === "bn") return bn_record(inputs)
	if (locale === "zh-TW") return zh_tw2_record(inputs)
	if (locale === "zh-HK") return zh_hk2_record(inputs)
	if (locale === "ur") return ur_record(inputs)
	if (locale === "fa") return fa_record(inputs)
	if (locale === "sw") return sw_record(inputs)
	if (locale === "nl") return nl_record(inputs)
	return en_record(inputs)
});